import { CodeEditor, type PinnedRange } from "../CodeEditor";
import type { FileSelection } from "./types";

const filePath = "output.txt";

type Props = {
  output: string;
  selectedRanges?: readonly PinnedRange[];
  onSelect?: (selections: FileSelection[]) => void;
};

export function Plain({ output, selectedRanges, onSelect }: Props) {
  return (
    <CodeEditor
      filePath={filePath}
      value={output}
      onSelectionChange={
        onSelect &&
        ((selections) =>
          onSelect(
            selections.map((s) => ({
              from: s.from,
              to: s.to,
              fromLine: s.fromLine,
              toLine: s.toLine,
              text: s.text,
            }))
          ))
      }
      pinnedRanges={selectedRanges}
    />
  );
}
